"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAjvErrorsText = exports.validateApiDefConfig = exports.validateSourceConfig = exports.customValidation = exports.packageToHandlerName = exports.isCustomHandler = void 0;
const ajv_1 = __importDefault(require("ajv"));
const _1 = require(".");
const datasources_1 = require("@graphql-portal/datasources");
function isCustomHandler(source) {
    const packageName = Object.keys(source.handler)[0];
    if (packageName in datasources_1.packageHandler) {
        return packageName;
    }
}
exports.isCustomHandler = isCustomHandler;
function packageToHandlerName(sourceArg) {
    const source = JSON.parse(JSON.stringify(sourceArg));
    const packageName = isCustomHandler(source);
    if (packageName) {
        source.handler[datasources_1.packageHandler[packageName]] = source.handler[packageName];
        delete source.handler[packageName];
    }
    return source;
}
exports.packageToHandlerName = packageToHandlerName;
function customValidation(source) {
    const packageName = isCustomHandler(source);
    if (!packageName)
        return;
    const validate = datasources_1.packageValidation[packageName];
    if (validate)
        return validate(source.name, source.handler[packageName]);
}
exports.customValidation = customValidation;
function validateSourceConfig(source) {
    const ajv = new ajv_1.default({ strict: false });
    const validate = ajv.compile(_1.sourceSchema);
    if (!validate(packageToHandlerName(source))) {
        return getAjvErrorsText(ajv, validate.errors, 'source');
    }
    return customValidation(source);
}
exports.validateSourceConfig = validateSourceConfig;
function validateApiDefConfig(apiDef) {
    const ajv = new ajv_1.default({ strict: false });
    const validate = ajv.compile(_1.apiDefSchema);
    if (!validate(apiDef)) {
        return getAjvErrorsText(ajv, validate.errors, 'apiDef');
    }
}
exports.validateApiDefConfig = validateApiDefConfig;
function getAjvErrorsText(ajv, errors, dataVar) {
    const keys = errors === null || errors === void 0 ? void 0 : errors.map(error => Object.values(error.params)).filter(Boolean).join(', ');
    let result = ajv.errorsText(errors, {
        dataVar,
    });
    if ((keys === null || keys === void 0 ? void 0 : keys.length) && !result.includes("'")) {
        result += `: ${keys}`;
    }
    return result;
}
exports.getAjvErrorsText = getAjvErrorsText;
//# sourceMappingURL=validation.js.map